import SocialPage from './socialPage.component';

export default SocialPage;